module.exports = __webpack_public_path__ + "img/cp3.c2d68e54.jpg";